/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui icons
import TelegramIcon from "@mui/icons-material/Telegram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";

import React from "react";
import "../YouTube/styles.css";
import VuiBox from "components/VuiBox/index";
import YoutubeEmbed from "../YouTube";
import { Grid } from "@mui/material";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";

const Welcome = () => {
  return (
    <VuiBox display="flex" flexDirection="column" sx={{ height: "100%" }}>
      <VuiBox>
        <YoutubeEmbed embedId="Muo5HnV6NMM" />
      </VuiBox>
    </VuiBox>
  );
};

export default Welcome;
